import useCallbackRef from 'hooks/useCallbackRef';
import { useEffect, useState } from 'react';

/** 특정 요소가 부모요소의 스크롤로 인해 원하는 위치에 sticky로 고정된 상태인지를 체크하여 상태를 반환
 * @params bg_dom: 부모요소 (useCallbackRef 훅을 사용할 것)
 * @params sticky_top?: sticky 상태로 판단할 기준 위치 (입력하지 않을 경우 88로 적용)
 * @return is_sticky: sticky 상태인지
 * @return targeRef: 타겟이 될 엘리먼트에 붙을 Ref
 */
const useGetStickyState = (bg_dom: HTMLElement | null, sticky_top = 88) => {
	const [is_sticky, setIsSticky] = useState(false);

	const [target_dom, targetRef] = useCallbackRef();

	useEffect(() => {
		if (bg_dom === null || target_dom === null) return;

		const scrollEvent = () => {
			const header_row_top = target_dom.getBoundingClientRect().top;

			if (header_row_top === sticky_top && !is_sticky) setIsSticky(true);
			if (header_row_top !== sticky_top && is_sticky) setIsSticky(false);
		};

		bg_dom.addEventListener('scroll', scrollEvent);

		return () => bg_dom.removeEventListener('scroll', scrollEvent);
	}, [target_dom, bg_dom, is_sticky]);

	return [is_sticky, targetRef] as [boolean, (node: HTMLElement | null) => void];
};

export default useGetStickyState;
